import { render, staticRenderFns } from "./customerStrategyAction.vue?vue&type=template&id=85826296"
import script from "./customerStrategyAction.vue?vue&type=script&lang=js"
export * from "./customerStrategyAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports